import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-type-identity.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParTypeIdentityDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const parTypeIdentityEntity = useAppSelector(state => state.parTypeIdentity.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parTypeIdentityDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.detail.title">ParTypeIdentity</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parTypeIdentityEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.code">Code</Translate>
            </span>
          </dt>
          <dd>{parTypeIdentityEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.name">Name</Translate>
            </span>
          </dt>
          <dd>{parTypeIdentityEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{parTypeIdentityEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{parTypeIdentityEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parTypeIdentity.status">Status</Translate>
            </span>
          </dt>
          <dd>{parTypeIdentityEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/par-type-identity" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-type-identity/${parTypeIdentityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParTypeIdentityDetail;
